import Image from 'next/image';
import React from 'react';

import NoListImage01 from '@/images/apps/common/no-list_img_01.svg';
import NoListImage02 from '@/images/apps/common/no-list_img_02.svg';

import NoListBodyText from './NoListBodyText';

type ColorType = 'black' | 'white';

type Props = {
  className?: string;
  color?: ColorType;
  titleText?: React.ReactNode;
  bodyText?: React.ReactNode;
  /** NoListButton만 사용 */
  buttonComponent?: React.ReactNode;
};

const COLOR_CLASS: Record<ColorType, string> = {
  black: 'text-apps-coreGrayBlack',
  white: 'text-apps-coreGrayWhite',
};

export default function NoList({
  className,
  color = 'black',
  titleText = '리스트가 없습니다.',
  bodyText,
  buttonComponent,
}: Props) {
  return (
    <div
      className={`flex w-full flex-col items-center justify-center py-[60px] text-xl font-medium leading-[150%] tracking-[-0.4px] lg:py-20 lg:text-[32px] lg:font-bold lg:leading-[120%] lg:tracking-[-0.64px] ${COLOR_CLASS[color]} ${className ?? ''}`}
    >
      <div className="relative mb-5 h-12 w-12 lg:mb-8 lg:h-[72px] lg:w-[72px]">
        <Image
          fill
          src={color === 'white' ? NoListImage02 : NoListImage01}
          alt="리스트 없음 아이콘"
        />
      </div>
      {titleText}
      {bodyText && <NoListBodyText color={color}>{bodyText}</NoListBodyText>}
      {buttonComponent && (
        <div className="mt-5 lg:mt-8">{buttonComponent}</div>
      )}
    </div>
  );
}
